import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import { obtenerListadoPersonasPorTipo } from '../../services/Persona/PersonaService';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IntegrantesCrud } from './IntegrantesCrud';
import { Senuelos } from './Senuelos';
import { ValidarEstatusButton } from './ValidarEstatusButton';
import { guardarCustodia, obtenerListaVehiculos, validarEvidenciasCustodia } from '../../services/Custodia/CustodiaService';
import { obtenerConfiguracionDet } from '../../services/Configuracion/ConfiguracionDetService';
import { ESTADO_CREADO_CODE, ESTADO_EN_INICIADO_CODE, ESTADO_FINALIZADO_CODE } from './data/custodiaDicctionary';
import { UsuarioService } from '../../services/Usuario/UsuarioService';
import { CargarEvidenciaCustodio } from './CargarEvidenciaCustodio';

const TIPO_COMPONENTES_CAB_CODE = 'CUS-0000-0002';
const TIPO_PERSONA_CLIENTE_CODE = 'PER-0000-0000-0003';

const TIPO_CUSTODIADO_EVIDENCIA_PLACA = '1';
const TIPO_CUSTODIADO_EVIDENCIA_CONDUCTOR = '2';
const CLIENTE_OTROS_ID = 3235;

export const CustodiaFormulario = ({ custodiaSeleccionada, onClose, onSuccessSave, toast, convertirFechaAISO, estadosList, onlyRead }) => {
    const [clientes, setClientes] = useState([]);

    const [custodiaFormulario, setCustodiaFormulario] = useState({});

    const [patrullas, setPatrullas] = useState([]);
    const [tiposComponentes, setTiposComponentes] = useState([]);
    const [custodioForm, setCustodioForm] = useState({});
    const [custodiadoForm, setCustodiadoForm] = useState({});
    const [componenteForm, setComponenteForm] = useState({});
    const [custodioSeleccionado, setCustodioSeleccionado] = useState(null);
    const [custodiadoDropdown, setCustodiadoDropdown] = useState(null);
    const [senuelosEdit, setSenuelosEdit] = useState({ senuelosList: null, objetctId: null, type: '' });
    const [changingStatus, setChangingStatus] = useState(false);
    const [mostrarCustodiadoEvidencia, setMostrarCustodiadoEvidencia] = useState({ custodiaId: null, origenId: null, tablaOrigen: null });

    const usuarioService = new UsuarioService();

    const [userFullName, setUserFullName] = useState('');

    useEffect(() => {
        const fetchUserName = async () => {
            try {
                if (!custodiaFormulario.usuarioCreacionId) {
                    setUserFullName('');
                    return;
                }

                const response = await usuarioService.getusuarioPorId(custodiaFormulario.usuarioCreacionId);
                setUserFullName(response.nombre || '');
            } catch (error) {
                console.error('Error al obtener el nombre de usuario:', error);
                setUserFullName('');
            }
        };

        fetchUserName();
    }, [custodiaFormulario.usuarioCreacionId]);

    useEffect(() => {
        // if (custodiaFormulario.clienteId ) {
        //     const clienteSeleccionado = clientes.find((c) => c.id === custodiaFormulario.clienteId);
        //     if (clienteSeleccionado) {
        //         setCustodiaFormulario((prevState) => ({
        //             ...prevState,
        //             nombreCliente: custodiaFormulario?.clienteId === CLIENTE_OTROS_ID ? clienteSeleccionado.nombre : prevState.nombreCliente,
        //         }));
        //     }
        // }

        if (custodiaFormulario.clienteId) {
            const clienteSeleccionado = clientes.find((c) => c.id === custodiaFormulario.clienteId);
            if (clienteSeleccionado) {
                setCustodiaFormulario((prevState) => ({
                    ...prevState,
                    nombreCliente: custodiaFormulario?.clienteId === CLIENTE_OTROS_ID ? prevState.nombreCliente : clienteSeleccionado.nombre,
                }) );
            }
        }
    }, [custodiaFormulario.clienteId, clientes]);

    useEffect(() => {
        if (custodiaSeleccionada) {
            obtenerClientes();

            setCustodiaFormulario(custodiaSeleccionada);
        }
        return () => {
            setCustodiaFormulario({});
            setCustodiadoDropdown(null);
        };
    }, [custodiaSeleccionada]);

    useEffect(() => {
        loadPatrullas();
        loadTiposComponentes();
    }, []);

    const loadTiposComponentes = async () => {
        try {
            const response = await obtenerConfiguracionDet(TIPO_COMPONENTES_CAB_CODE);
            setTiposComponentes(response.map((item) => ({ id: item.configuracionDetId, nombre: item.nombre })));
        } catch (error) {
            console.error('Error al cargar tipos de componentes:', error);
        }
    };

    const loadPatrullas = async () => {
        // Lógica para cargar patrullas
        try {
            const response = await obtenerListaVehiculos();
            setPatrullas(response.data?.data || []);
        } catch (error) {
            console.error('Error al cargar patrullas:', error);
        }
    };

    const obtenerClientes = async () => {
        // Lógica para obtener clientes según el filtro
        try {
            const response = await obtenerListadoPersonasPorTipo(TIPO_PERSONA_CLIENTE_CODE);
            setClientes(response.data.map((cliente) => ({ id: cliente.personaId, nombre: cliente.nombre, correo: cliente.correoElectronico })));
        } catch (error) {
            console.error('Error al obtener clientes:', error);
        }
    };

    const onStartEditCustodio = (custodio) => {
        setCustodioForm({ ...custodio });
    };

    const accionesBodyTemplate = (rowData) => {
        return (
            <div className="flex flex-row gap-1">
                <Button
                    icon="pi pi-pencil"
                    tooltip="Editar"
                    className="p-button-rounded"
                    onClick={() => onStartEditCustodio({ ...rowData, patrullaId: rowData.patrullaId?.id })}
                    disabled={onlyRead || custodiaFormulario.estadoCode === ESTADO_FINALIZADO_CODE || onlyRead}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-danger ml-2 p-button-rounded"
                    tooltip="Eliminar"
                    onClick={() => {
                        setCustodiaFormulario((prevState) => ({
                            ...prevState,
                            patrullas: prevState.patrullas.filter((c) => c.id !== rowData.id)
                        }));
                        setCustodioForm({});
                    }}
                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                />
                <Button icon="pi pi-users" className="p-button-info ml-2 p-button-rounded" tooltip="Ver integrantes" onClick={() => setCustodioSeleccionado({ ...rowData, nombre: patrullas.find((p) => p.id === rowData.dispositivoId)?.nombre })} />
            </div>
        );
    };

    const handleGuardarCustodio = () => {
        //validar que exista dispositivoId
        if (!custodioForm.dispositivoId) {
            return; // Salir si no hay dispositivoId
        }

        // Aquí podrías agregar la lógica para enviar los datos al backend o actualizar el estado
        const custodio = {
            id: custodioForm.id || `temp-${Date.now()}`, // Generar un ID temporal si no existe
            dispositivoId: custodioForm.dispositivoId,
            kilometrajeInicio: custodioForm.kilometrajeInicio,
            kilometrajeFin: custodioForm.kilometrajeFin,
            integrantes: custodioForm.integrantes || []
        };

        // validar que si ya existe un custodio con el mismo id lo actualice en lugar de agregar uno nuevo
        setCustodiaFormulario((prevState) => {
            // validar custodios nulo o falle
            if (!prevState.patrullas) {
                return { ...prevState, patrullas: [custodio] };
            }
            const index = prevState.patrullas?.findIndex((c) => c.id === custodio.id);
            if (index !== -1) {
                const updatedPatrullas = [...prevState.patrullas];
                updatedPatrullas[index] = custodio;
                return { ...prevState, patrullas: updatedPatrullas };
            }
            return { ...prevState, patrullas: [...(prevState.patrullas || []), custodio] };
        });

        setCustodioForm({});
    };

    const onHandleSaveIntegrantes = (patrullaId, integrantes) => {
        // Lógica para manejar el guardado de integrantes
        console.log('Guardando integrantes para el patrulla:', patrullaId, integrantes);
        setCustodiaFormulario((prevState) => {
            const updatedPatrullas = prevState.patrullas.map((c) => {
                if (c.id === patrullaId) {
                    return { ...c, integrantes };
                }
                return c;
            });
            return { ...prevState, patrullas: updatedPatrullas };
        });
        setCustodioSeleccionado(null);
    };

    const handleGuardarCustodiado = () => {
        //validar que tenga placa y conductor
        if (!custodiadoForm.placa || !custodiadoForm.conductor) {
            return; // Salir si no hay placa o conductor
        }
        // Lógica para guardar el custodiado
        const custodiado = {
            id: custodiadoForm.id || `temp-${Date.now()}`,
            placa: custodiadoForm.placa,
            conductor: custodiadoForm.conductor
        };
        setCustodiaFormulario((prevState) => {
            // validar custodiados nulo o falle
            if (!prevState.custodiados) {
                return { ...prevState, custodiados: [custodiado] };
            }
            const index = prevState.custodiados?.findIndex((c) => c.id === custodiado.id);
            if (index !== -1) {
                const updatedCustodiados = [...prevState.custodiados];
                updatedCustodiados[index] = custodiado;
                return { ...prevState, custodiados: updatedCustodiados };
            }
            return { ...prevState, custodiados: [...(prevState.custodiados || []), custodiado] };
        });
        setCustodiadoForm({});
    };

    const onDeleteCustodiado = (rowData) => {
        setCustodiaFormulario((prevState) => ({
            ...prevState,
            custodiados: prevState.custodiados.filter((custodiado) => custodiado.id !== rowData.id)
        }));
    };

    const accionesCustodiadoTemplate = (rowData) => {
        return (
            <div className="flex flex-row gap-1">
                <Button icon="pi pi-pencil" tooltip="Editar" className="p-button-rounded" onClick={() => setCustodiadoForm({ ...rowData })} disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead} />
                <Button
                    icon="pi pi-trash"
                    className="p-button-danger ml-2 p-button-rounded"
                    tooltip="Eliminar"
                    onClick={() => {
                        onDeleteCustodiado(rowData);
                    }}
                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                />
                <Button icon="pi pi-eye" className="p-button-rounded ml-2" tooltip="Señuelos" onClick={() => setSenuelosEdit({ senuelosList: rowData.senuelos || [], objectId: rowData.id, type: 'custodiado' })} />
            </div>
        );
    };

    const handleGuardarComponente = () => {
        // Lógica para guardar el componente asociado al custodiado seleccionado
        if (!custodiadoDropdown) return;

        const componente = {
            id: componenteForm.id || `temp-${Date.now()}`,
            tipo: componenteForm.tipo,
            codigo: componenteForm.codigo,
            senuelos: componenteForm.senuelos || []
        };
        setCustodiaFormulario((prevState) => {
            const updatedCustodiados = prevState.custodiados.map((custodiado) => {
                if (custodiado.id === custodiadoDropdown) {
                    // Validar si el componente ya existe en el custodiado
                    let componentes = custodiado.componentes || [];
                    const index = componentes.findIndex((c) => c.id === componente.id);
                    if (index !== -1) {
                        componentes[index] = componente;
                    } else {
                        componentes = [...componentes, componente];
                    }
                    return { ...custodiado, componentes };
                }
                return custodiado;
            });
            return { ...prevState, custodiados: updatedCustodiados };
        });
        setComponenteForm({});
    };

    const onDeleteComponente = (rowData) => {
        if (!custodiadoDropdown) return;
        setCustodiaFormulario((prevState) => {
            const updatedCustodiados = prevState.custodiados.map((custodiado) => {
                if (custodiado.id === custodiadoDropdown) {
                    const componentes = (custodiado.componentes || []).filter((c) => c.id !== rowData.id);
                    return { ...custodiado, componentes };
                }
                return custodiado;
            });
            return { ...prevState, custodiados: updatedCustodiados };
        });
        setComponenteForm({});
    };

    const componentRowTemplate = (rowData) => {
        return (
            <div className="flex flex-row gap-1">
                <Button icon="pi pi-pencil" tooltip="Editar" className="p-button-rounded" onClick={() => setComponenteForm(rowData)} disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead} />
                <Button
                    icon="pi pi-trash"
                    className="p-button-danger ml-2 p-button-rounded"
                    tooltip="Eliminar"
                    onClick={() => {
                        onDeleteComponente(rowData);
                    }}
                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                />
                {/* Botón señuelos y evidencias */}
                <Button icon="pi pi-eye" className="p-button-rounded ml-2" tooltip="Señuelos" onClick={() => setSenuelosEdit({ senuelosList: rowData.senuelos || [], objectId: rowData.id, type: 'componente' })} />
                {/* mostrar solo cuando no sea id temporal */}
                <Button
                    icon="pi pi-image"
                    className="p-button-rounded ml2"
                    tooltip="Cargar Evidencia"
                    onClick={() => setMostrarCustodiadoEvidencia({ custodiaId: custodiaFormulario.id, origenId: rowData.id, tablaOrigen: '5' })}
                    disabled={(typeof rowData.id === 'string' && rowData.id.startsWith('temp-')) || onlyRead}
                />
            </div>
        );
    };

    const onSuccesSaveSenuelos = (senuelosList) => {
        if (!senuelosEdit.objectId) return;
        if (senuelosEdit.type === 'custodiado') {
            setCustodiaFormulario((prevState) => {
                const updatedCustodiados = prevState.custodiados.map((custodiado) => {
                    if (custodiado.id === senuelosEdit.objectId) {
                        return { ...custodiado, senuelos: senuelosList };
                    }
                    return custodiado;
                });
                return { ...prevState, custodiados: updatedCustodiados };
            });
        } else if (senuelosEdit.type === 'componente') {
            setCustodiaFormulario((prevState) => {
                const updatedCustodiados = prevState.custodiados.map((custodiado) => {
                    const updatedComponentes = (custodiado.componentes || []).map((componente) => {
                        if (componente.id === senuelosEdit.objectId) {
                            return { ...componente, senuelos: senuelosList };
                        }
                        return componente;
                    });
                    return { ...custodiado, componentes: updatedComponentes };
                });
                return { ...prevState, custodiados: updatedCustodiados };
            });
        }
        setSenuelosEdit({ senuelosList: null, objectId: null, type: '' });
    };

    const validarFormulario = () => {
        //validar que tenga cliente y fecha de inicio
        if (!custodiaFormulario.nombreCliente || custodiaFormulario.nombreCliente.trim() === '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar un cliente' });
            return false;
        }

        //validar que tenga completo lo de rutas
        if (!custodiaFormulario.origen || !custodiaFormulario.destino) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe completar las rutas de origen y destino' });
            return false;
        }

        //debe tener al menos un custodio
        if (!custodiaFormulario.patrullas || custodiaFormulario.patrullas.length === 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe agregar al menos un custodio' });
            return false;
        }
        //validar que todos los custodios tengan al menos un integrante
        if (custodiaFormulario.patrullas.some((c) => !c.integrantes || c.integrantes.length === 0)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Cada custodio debe tener al menos un integrante' });
            return false;
        }

        //debe tener al menos un custodiado
        if (!custodiaFormulario.custodiados || custodiaFormulario.custodiados.length === 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe agregar al menos un custodiado' });
            return false;
        }

        return true;
    };

    const procesarIdsTemporales = (jsonObj) => {
        // Si no es un objeto o es null, retornar tal cual
        if (typeof jsonObj !== 'object' || jsonObj === null) {
            return jsonObj;
        }

        // Si es un array, procesar cada elemento
        if (Array.isArray(jsonObj)) {
            return jsonObj.map((item) => procesarIdsTemporales(item));
        }

        // Si es un objeto, procesar sus propiedades
        const resultado = {};

        for (const key in jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, key)) {
                const value = jsonObj[key];

                // Si la clave es exactamente "id" y el valor es un string que comienza con "temp-"
                if (key === 'id' && typeof value === 'string' && value.startsWith('temp-')) {
                    resultado[key] = null;
                } else {
                    // Para cualquier otro caso, procesar recursivamente
                    resultado[key] = procesarIdsTemporales(value);
                }
            }
        }

        return resultado;
    };

    const onStartSaveCustodia = async () => {
        //validar
        if (!validarFormulario()) {
            return;
        }

        //lógica para guardar la custodia
        try {
            const custodiaToSave = procesarIdsTemporales(custodiaFormulario);

            const fechaInicio = convertirFechaAISO(custodiaFormulario.fechaInicio);
            const fechaFin = convertirFechaAISO(custodiaFormulario.fechaFin);
            const fechaCreacion = convertirFechaAISO(custodiaFormulario.fechaCreacion);

            const response = await guardarCustodia({ ...custodiaToSave, fechaInicio, fechaFin, fechaCreacion, correoElectronicoCliente: custodiaFormulario.correoElectronicoCliente?.join(';') });
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Custodia guardada correctamente' });
            onSuccessSave(response.data);
        } catch (error) {
            console.error('Error al guardar la custodia:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al guardar la custodia' });
            return;
        }
    };

    const validarIniciarCustodia = () => {
        //validar que la custodia esté en estado creado
        if (custodiaFormulario.estadoCode !== ESTADO_CREADO_CODE) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La custodia no está en estado creado' });
            return false;
        }

        //validar que tenga fecha de inicio
        if (!custodiaFormulario.fechaInicio) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La custodia debe tener una fecha de inicio' });
            return false;
        }

        //validar que tenga al menos una patrulla
        if (!custodiaFormulario.patrullas || custodiaFormulario.patrullas.length === 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La custodia debe tener al menos una patrulla asignada' });
            return false;
        }
        //validar que cada patrulla tenga al menos un integrante
        if (custodiaFormulario.patrullas.some((p) => !p.integrantes || p.integrantes.length === 0)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Cada patrulla debe tener al menos un integrante' });
            return false;
        }
        //validar que todas las patrullas tengan kilometraje de inicio
        if (custodiaFormulario.patrullas.some((p) => !p.kilometrajeInicio)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Cada patrulla debe tener el kilometraje de inicio registrado' });
            return false;
        }
        //validar que tenga al menos un custodiado
        if (!custodiaFormulario.custodiados || custodiaFormulario.custodiados.length === 0) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La custodia debe tener al menos un custodiado' });
            return false;
        }

        return true;
    };

    const validarComponenteEvidencia = async (custodiaId, tipo) => {
        try {
            const response = await validarEvidenciasCustodia(custodiaId, tipo);
            const { respuesta, descripcion } = response.data;
            if (!respuesta) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: descripcion || 'Faltan evidencias obligatorias', sticky: true });
                return false;
            }
            return true;
        } catch (error) {
            console.error('Error al validar componentes de evidencia:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al validar los componentes de evidencia' });
        }
    };

    const iniciarCustodia = async () => {
        try {
            setChangingStatus(true);
            if (!validarIniciarCustodia()) {
                return;
            }

            const esValido = await validarComponenteEvidencia(custodiaFormulario.id, 0);
            if (!esValido) {
                return;
            }
            // Lógica para iniciar la custodia
            const custodiaToSave = procesarIdsTemporales(custodiaFormulario);

            const fechaCreacion = convertirFechaAISO(custodiaFormulario.fechaCreacion);
            const fechaInicio = convertirFechaAISO(custodiaFormulario.fechaInicio);
            const fechaFin = null;

            const estadoIniciado = estadosList.find((e) => e.codigo === ESTADO_EN_INICIADO_CODE);
            if (!estadoIniciado) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se encontró el estado de custodia iniciado' });
                return;
            }
            const response = await guardarCustodia({ ...custodiaToSave, fechaInicio, fechaFin, fechaCreacion, estado: estadoIniciado?.configuracionDetId, correoElectronicoCliente: custodiaFormulario.correoElectronicoCliente?.join(';') });
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Custodia iniciada correctamente' });
            onSuccessSave(response.data);
        } catch (error) {
            console.error('Error al iniciar la custodia:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al iniciar la custodia' });
            return;
        } finally {
            setChangingStatus(false);
        }
    };

    const validarFinalizarCustodia = () => {
        //validar que la custodia esté en estado iniciado
        if (custodiaFormulario.estadoCode !== ESTADO_EN_INICIADO_CODE) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La custodia no está en estado iniciado' });
            return false;
        }

        //validar que tenga fecha de fin
        if (!custodiaFormulario.fechaFin) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La custodia debe tener una fecha de fin' });
            return false;
        }

        //validar que todas las patrullas tengan kilometraje de fin
        if (custodiaFormulario.patrullas.some((p) => !p.kilometrajeFin)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Cada patrulla debe tener el kilometraje de fin registrado' });
            return false;
        }
        return true;
    };

    const finalizarCustodia = async () => {
        try {
            setChangingStatus(true);
            if (!validarFinalizarCustodia()) {
                return;
            }
            const esValido = await validarComponenteEvidencia(custodiaFormulario.id, 1);
            if (!esValido) {
                return;
            }
            // Lógica para finalizar la custodia
            const custodiaToSave = procesarIdsTemporales(custodiaFormulario);
            const fechaCreacion = convertirFechaAISO(custodiaFormulario.fechaCreacion);
            const fechaInicio = convertirFechaAISO(custodiaFormulario.fechaInicio);
            const fechaFin = convertirFechaAISO(custodiaFormulario.fechaFin);
            const estadoFinalizado = estadosList.find((e) => e.codigo === ESTADO_FINALIZADO_CODE);
            if (!estadoFinalizado) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se encontró el estado de custodia finalizado' });
                return;
            }
            const response = await guardarCustodia({ ...custodiaToSave, fechaInicio, fechaFin, fechaCreacion, estado: estadoFinalizado?.configuracionDetId, correoElectronicoCliente: custodiaFormulario.correoElectronicoCliente.join(';') });
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Custodia finalizada correctamente' });
            onSuccessSave(response.data);
        } catch (error) {
            console.error('Error al finalizar la custodia:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al finalizar la custodia' });
            return;
        } finally {
            setChangingStatus(false);
        }
    };

    const footerTemplate = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onClose} />
            <Button label="Guardar" icon="pi pi-check" className="p-button-text" onClick={onStartSaveCustodia} disabled={onlyRead || custodiaFormulario.estadoCode !== ESTADO_CREADO_CODE} />
        </div>
    );

    const openEvidenciaGeneral = (tablaOrigen, origenId) => {
        setMostrarCustodiadoEvidencia({ custodiaId: custodiaFormulario.id, origenId, tablaOrigen: tablaOrigen });
    };

    const placaCustodiadoTemplate = (rowData) => {
        return (
            <div className="flex flex-row align-items-center">
                <span>{rowData.placa}</span>
                <Button
                    icon="pi pi-image"
                    className="p-button-rounded p-button-text ml-2"
                    tooltip="Cargar Evidencia"
                    onClick={() => openEvidenciaGeneral(TIPO_CUSTODIADO_EVIDENCIA_PLACA, rowData.id)}
                    disabled={(typeof rowData.id === 'string' && rowData.id.startsWith('temp-')) || onlyRead}
                />
            </div>
        );
    };

    const conductorCustodiadoTemplate = (rowData) => {
        return (
            <div className="flex flex-row align-items-center">
                <span>{rowData.conductor}</span>
                <Button
                    icon="pi pi-image"
                    className="p-button-rounded p-button-text ml-2"
                    tooltip="Cargar Evidencia"
                    onClick={() => openEvidenciaGeneral(TIPO_CUSTODIADO_EVIDENCIA_CONDUCTOR, rowData.id)}
                    disabled={(typeof rowData.id === 'string' && rowData.id.startsWith('temp-')) || onlyRead}
                />
            </div>
        );
    };

    return (
        <Dialog visible={custodiaSeleccionada !== null} header={`${custodiaSeleccionada?.id ? 'Editar Custodia' : 'Agregar Custodia'}`} modal className="p-fluid w-full md:w-11 lg:w-8" footer={footerTemplate} onHide={onClose} closable={false}>
            <div className="col-12">
                <div className="card p-fluid">
                    <h5>GENERAL</h5>
                    <div className="formgrid flex flex-column md:flex-row lg:flex-row sm:flex-row">
                        <div className="field col">
                            <label htmlFor="clienteList">Cliente</label>
                            <div className="p-inputgroup flex align-items-center">
                                <Dropdown
                                    id="clienteList"
                                    options={clientes}
                                    optionValue="id"
                                    optionLabel="nombre"
                                    value={custodiaFormulario?.clienteId}
                                    onChange={(e) => setCustodiaFormulario({ ...custodiaFormulario, clienteId: e.value })}
                                    placeholder="Selecciona un cliente"
                                    filter
                                    className="w-full md:w-14rem"
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col">
                            <label htmlFor="estadoCandado">Nombre</label>
                            <div className="p-inputgroup">
                                <InputText
                                    disabled={custodiaFormulario?.clienteId !== CLIENTE_OTROS_ID || onlyRead}
                                    id="nombreCustodia"
                                    value={custodiaFormulario?.nombreCliente || ''}
                                    placeholder="Nombre del cliente"
                                    className="w-full md:w-14rem"
                                    onChange={(e) => setCustodiaFormulario({ ...custodiaFormulario, nombreCliente: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="formgrid flex flex-column md:flex-row lg:flex-row sm:flex-row">
                        <div className="field col">
                            <label htmlFor="estadoCandado">Fecha Inicio</label>
                            <div className="p-inputgroup">
                                <Calendar
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                    id="fechaInicio"
                                    value={custodiaFormulario.fechaInicio}
                                    onChange={(e) => setCustodiaFormulario({ ...custodiaFormulario, fechaInicio: e.value })}
                                    showIcon
                                    showTime
                                    hourFormat="24"
                                    dateFormat="dd/mm/yy"
                                    className="w-full md:w-14rem"
                                />
                            </div>
                        </div>
                        <div className="field col">
                            <label htmlFor="estadoCandado">Fecha Fin</label>
                            <div className="p-inputgroup">
                                <Calendar
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_EN_INICIADO_CODE || onlyRead}
                                    id="fechaFin"
                                    value={custodiaFormulario.fechaFin}
                                    onChange={(e) => setCustodiaFormulario({ ...custodiaFormulario, fechaFin: e.value })}
                                    showIcon
                                    dateFormat="dd/mm/yy"
                                    className="w-full md:w-14rem"
                                    showTime
                                    hourFormat="24"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card p-fluid">
                    <h5>RUTA</h5>
                    <div className="flex flex-column lg:flex-row lg:align-items-end">
                        <div className="flex flex-column md:flex-row lg:flex-row sm:flex-row col-12 lg:col-8">
                            <div className="field col col-12 md:col-6 lg:col-6 sm:col-6">
                                <label htmlFor="origenInput">Origen</label>
                                <div className="p-inputgroup">
                                    <InputText
                                        id="origenInput"
                                        value={custodiaFormulario.origen || ''}
                                        onChange={(e) => setCustodiaFormulario({ ...custodiaFormulario, origen: e.target.value })}
                                        placeholder="Ingresa el origen"
                                        className="col-12 md:col-6 lg:col-3 sm:col-6"
                                        disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                    />
                                </div>
                            </div>
                            <div className="field col col-12 md:col-6 lg:col-6 sm:col-6">
                                <label htmlFor="destinoInput">Destino</label>
                                <div className="p-inputgroup">
                                    <InputText
                                        id="destinoInput"
                                        value={custodiaFormulario.destino || ''}
                                        onChange={(e) => setCustodiaFormulario({ ...custodiaFormulario, destino: e.target.value })}
                                        placeholder="Ingresa el destino"
                                        className="col-12 md:col-6 lg:col-3 sm:col-6"
                                        disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="field col-12 lg:col-4">
                            {custodiaFormulario?.estadoCode === ESTADO_CREADO_CODE && custodiaFormulario.id && (
                                <Button loading={changingStatus} icon="pi pi-star" className="p-button-warning" label="Iniciar Custodia" onClick={iniciarCustodia} disabled={onlyRead} />
                            )}
                            {custodiaFormulario?.estadoCode === ESTADO_EN_INICIADO_CODE && <Button loading={changingStatus} icon="pi pi-star" className="p-button-danger" label="Finalizar Custodia" onClick={finalizarCustodia} disabled={onlyRead} />}
                            {custodiaFormulario?.estadoCode === ESTADO_FINALIZADO_CODE && ''}
                        </div>
                    </div>
                </div>
                <div className="card p-fluid">
                    <h5>CUSTODIO</h5>
                    <div className="flex flex-column md:flex-row my-4">
                        <div className="font-bold">Jefe de patrulla: </div>
                        <div className="ml-2">{userFullName}</div>
                    </div>
                    <div className="grid  flex flex-column md:flex-row lg:flex-row sm:flex-row">
                        <div className="field col">
                            <label htmlFor="patrullaList">Patrulla</label>
                            <div className="p-inputgroup">
                                <Dropdown
                                    id="patrullaList"
                                    options={patrullas}
                                    optionValue="dispositivoId"
                                    optionLabel="nombre"
                                    value={custodioForm.dispositivoId}
                                    onChange={(e) => setCustodioForm({ ...custodioForm, dispositivoId: e.value })}
                                    placeholder="Selecciona un dispositivo"
                                    filter
                                    className="w-full md:w-14rem"
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col">
                            <label htmlFor="kilometrajeInicio">Kilometraje Inicio</label>
                            <div className="p-inputgroup">
                                <InputText
                                    id="kilometrajeInicio"
                                    placeholder="Ingresa el kilometraje de inicio"
                                    keyfilter={'int'}
                                    className="w-full md:w-14rem"
                                    value={custodioForm.kilometrajeInicio || ''}
                                    onChange={(e) => setCustodioForm({ ...custodioForm, kilometrajeInicio: e.target.value })}
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col">
                            <label htmlFor="kilometrajeFin">Kilometraje Fin</label>
                            <div className="p-inputgroup">
                                <InputText
                                    id="kilometrajeFin"
                                    keyfilter={'int'}
                                    placeholder="Ingresa el kilometraje de fin"
                                    className="w-full md:w-14rem"
                                    value={custodioForm.kilometrajeFin || ''}
                                    onChange={(e) => setCustodioForm({ ...custodioForm, kilometrajeFin: e.target.value })}
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_EN_INICIADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-end">
                            <Button icon="pi pi-save" className="p-button-success" tooltip="Guardar" onClick={handleGuardarCustodio} disabled={onlyRead} />
                            <Button icon="pi pi-times" className="p-button-secondary ml-2" tooltip="Limpiar" onClick={() => setCustodioForm({})} />
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-end">
                            <ValidarEstatusButton dispositivoId={custodioForm.dispositivoId} />
                        </div>
                    </div>
                    <div className="col-12">
                        {/* Aquí iría la tabla de custodios agregados */}
                        <DataTable responsiveLayout="scroll" value={custodiaFormulario.patrullas || []} className="mt-4">
                            <Column header="Patrulla" body={(rowData) => patrullas.find((dispositivo) => dispositivo.dispositivoId === rowData.dispositivoId)?.nombre} />
                            <Column field="kilometrajeInicio" header="Kilometraje Inicio" />
                            <Column field="kilometrajeFin" header="Kilometraje Fin" />
                            <Column header="Acciones" body={accionesBodyTemplate} />
                        </DataTable>
                    </div>

                    <IntegrantesCrud patrullaSelected={custodioSeleccionado} onClose={() => setCustodioSeleccionado(null)} onSuccesSave={onHandleSaveIntegrantes} estadoCustodia={custodiaFormulario?.estadoCode} onlyRead={onlyRead} />
                </div>
                <div className="card p-fluid">
                    <h5>CLIENTE</h5>
                    <div className="grid flex flex-column md:flex-row lg:flex-row sm:flex-row">
                        <div className="field col">
                            <label htmlFor="placaInput">Placa</label>
                            <div className="p-inputgroup">
                                <InputText
                                    id="placaInput"
                                    value={custodiadoForm.placa || ''}
                                    onChange={(e) => setCustodiadoForm({ ...custodiadoForm, placa: e.target.value })}
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col">
                            <label htmlFor="conductorInput">Conductor</label>
                            <div className="p-inputgroup">
                                <InputText
                                    id="conductorInput"
                                    value={custodiadoForm.conductor || ''}
                                    onChange={(e) => setCustodiadoForm({ ...custodiadoForm, conductor: e.target.value })}
                                    disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-end">
                            <Button icon="pi pi-save" className="p-button-success" tooltip="Guardar" onClick={handleGuardarCustodiado} disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead} />
                            <Button icon="pi pi-times" className="p-button-secondary ml-2" tooltip="Limpiar" onClick={() => setCustodiadoForm({})} disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE} />
                        </div>
                        <div className="col-12">
                            {/* Aquí iría la tabla de custodiados agregados */}
                            <DataTable responsiveLayout="scroll" value={custodiaFormulario.custodiados || []} className="mt-4">
                                <Column field="placa" header="Placa" body={placaCustodiadoTemplate} />
                                <Column field="conductor" header="Conductor" body={conductorCustodiadoTemplate} />
                                <Column header="Acciones" body={accionesCustodiadoTemplate} />
                            </DataTable>
                        </div>
                    </div>
                </div>
                <div className="card p-fluid">
                    <h5>COMPONENTES</h5>
                    <div className="grid flex flex-column md:flex-row lg:flex-row sm:flex-row">
                        <div className="field col md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="custodiadoInput">Clientes</label>
                            <div className="p-inputgroup">
                                <Dropdown
                                    id="custodiadoInput"
                                    options={custodiaFormulario.custodiados || []}
                                    optionValue="id"
                                    optionLabel="placa"
                                    placeholder="Selecciona un cliente"
                                    filter
                                    className="w-full md:w-14rem"
                                    value={custodiadoDropdown}
                                    onChange={(e) => setCustodiadoDropdown(e.value)}
                                    showClear
                                />
                            </div>
                        </div>
                    </div>
                    <div className="grid flex flex-column md:flex-row lg:flex-row sm:flex-row">
                        <div className="field col md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="tipoComponenteInput">Tipo de Componente</label>
                            <div className="p-inputgroup">
                                <Dropdown
                                    id="tipoComponenteInput"
                                    placeholder="Ingresa el tipo de componente"
                                    className="w-full md:w-14rem"
                                    value={componenteForm.tipo || ''}
                                    onChange={(e) => setComponenteForm({ ...componenteForm, tipo: e.value })}
                                    options={tiposComponentes}
                                    optionValue="id"
                                    optionLabel="nombre"
                                    disabled={!custodiadoDropdown || custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col md:col-6 lg:col-3 sm:col-6">
                            <label htmlFor="codigoComponenteInput">Serie</label>
                            <div className="p-inputgroup">
                                <InputText
                                    id="codigoComponenteInput"
                                    placeholder="Ingresa la serie de componente"
                                    className="w-full md:w-14rem"
                                    value={componenteForm.codigo || ''}
                                    onChange={(e) => setComponenteForm({ ...componenteForm, codigo: e.target.value })}
                                    disabled={!custodiadoDropdown || custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead}
                                />
                            </div>
                        </div>
                        <div className="field col-12 md:col-3 flex align-items-end">
                            <Button icon="pi pi-save" className="p-button-success" tooltip="Guardar" onClick={handleGuardarComponente} disabled={!custodiadoDropdown || custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE || onlyRead} />
                            <Button icon="pi pi-times" className="p-button-secondary ml-2" tooltip="Limpiar" onClick={() => setComponenteForm({})} disabled={custodiaFormulario?.estadoCode !== ESTADO_CREADO_CODE} />
                        </div>
                        <div className="col-12">
                            {/* Aquí iría la tabla de componentes del custodiado seleccionado */}
                            <DataTable responsiveLayout="scroll" value={custodiadoDropdown ? (custodiaFormulario.custodiados || []).find((c) => c.id === custodiadoDropdown)?.componentes || [] : []} className="mt-4">
                                <Column header="Tipo" body={(rowData) => tiposComponentes.find((t) => t.id === rowData.tipo)?.nombre} />
                                <Column field="codigo" header="Serie" />
                                <Column header="Acciones" body={componentRowTemplate} />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <Senuelos
                openEvidenciaGeneral={openEvidenciaGeneral}
                senuelosEdit={senuelosEdit.senuelosList}
                onClose={() => setSenuelosEdit({ senuelosList: null, objectId: null, type: '' })}
                onSuccesSave={onSuccesSaveSenuelos}
                estadoCustodia={custodiaFormulario?.estadoCode}
                tablaOrigen={senuelosEdit.type}
                onlyRead={onlyRead}
            ></Senuelos>

            <CargarEvidenciaCustodio
                custodiaId={mostrarCustodiadoEvidencia?.custodiaId}
                estadoCustodia={custodiaFormulario?.estadoCode}
                onHide={() => setMostrarCustodiadoEvidencia({})}
                origenId={mostrarCustodiadoEvidencia?.origenId}
                tablaOrigen={mostrarCustodiadoEvidencia?.tablaOrigen}
            />
        </Dialog>
    );
};
